import { createGaActionCreator } from '../../utils';
import { SELECT_PATIENT_GA_CATEGORY, GaActionText } from './constants';

const TRACK_CLICK_CONTINUE = '@@selectpatient/TRACK_CLICK_CONTINUE';
const TRACK_ME_PATIENT_FIELD_SELECT =
    '@@selectpatient/TRACK_ME_PATIENT_FIELD_SELECT';
const TRACK_NEW_SUB_PATIENT_FIELD_SELECT =
    '@@selectpatient/TRACK_NEW_SUB_PATIENT_FIELD_SELECT';
const TRACK_EXISTING_SUB_PATIENT_FIELD_SELECT =
    '@@selectpatient/TRACK_EXISTING_SUB_PATIENT_FIELD_SELECT';

export const SelectPatientPageActions = {
    TRACK_CLICK_CONTINUE,
    TRACK_ME_PATIENT_FIELD_SELECT,
    TRACK_NEW_SUB_PATIENT_FIELD_SELECT,
    TRACK_EXISTING_SUB_PATIENT_FIELD_SELECT,
};

/*
    Tracking Actions
*/

export const trackClickContinue = () =>
    createGaActionCreator(
        TRACK_CLICK_CONTINUE,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackClickContinue
    );

export const trackMePatientFieldSelect = () =>
    createGaActionCreator(
        TRACK_ME_PATIENT_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackMePatientFieldSelect
    );

export const trackNewSubPatientFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_SUB_PATIENT_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackNewSubPatientFieldSelect
    );

export const trackExistingSubPatientFieldSelect = () =>
    createGaActionCreator(
        TRACK_EXISTING_SUB_PATIENT_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackExistingSubPatientFieldSelect
    );

export const SelectPatientPageTrackingActionCreators = {
    trackClickContinue,
    trackMePatientFieldSelect,
    trackNewSubPatientFieldSelect,
    trackExistingSubPatientFieldSelect,
};
